import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPageNotFound = loadable(() => import(/* webpackChunkName: "content/pagenotfound-ssr" */ '.'));
